module.exports = __webpack_public_path__ + "static/media/options-spanish.d34d8ede.png";